<template>
  <div class="kpi-table-header" :class="gridClass">
    <div class="kpi-table-header__label">KPI</div>
    <div  v-for="(wave, index) in waves"
          :key="index"
          class="kpi-table-header__wave"
          :class="{ 'kpi-table-header__wave--current': wave.isCurrent }">
      {{ niceWaveName(wave.Name) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiTableHeader',

  props: {
    column: {
      type: Object,
      required: true
    }
  },

  computed: {
    waves() {
      return this.column.isExpanded
        ? this.column.waves
        : this.column.waves.slice(-1);
    },
    gridClass() {
      if (this.column?.isExpanded) {
        return 'kpi-table-header--multi';
      }
      return 'kpi-table-header--single';
    }
  },

  methods: {
    niceWaveName(waveName) {
      let candidate = waveName.replace('-', '').replace(' ', '').replace(/_/g, '')
        .replace('Wave', 'W').replace('Welle', 'W').replace(' ', '');

        if (candidate.length === 6) {
        return `${candidate.substring(4, 6)}/${candidate.substring(0, 4)}`;
      }
      return waveName;
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-table-header {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  // background-color: var(--bs-gray-100);
  padding: 0.5rem;
  border-bottom: 1px solid var(--bs-border-color);

  &--single {
    display: grid;
    grid-template-columns: minmax(8rem, 1fr) repeat(1, 4rem);
    gap: 0.125rem;
    .kpi-table-header__wave {
      width: 3rem;
    }
  }

  &--multi {
    display: grid;
    grid-template-columns: minmax(8rem, 1fr) repeat(v-bind('waves.length'), 4rem);
    gap: 0.125rem;
  }
}

.kpi-table-header__label {
  flex: 1;
  font-size: 0.75rem;
  color: var(--bs-gray-600);
}

.kpi-table-header__wave {
  text-align: center;
  font-size: 0.75rem;
  color: var(--bs-gray-600);

  &--current {
    font-weight: 700;
  }
}
</style>
